import {Component, Inject} from '@angular/core';
import {Option} from '../../model/GeneralModels';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {IntroductionLetterScenario, Subset, SubsetDetails} from '../../model/IntroductionLetterModel';

interface DialogData {
  relationList: Option[];
}

@Component({
  selector: 'app-subset-dialog',
  template: `
    <h1 mat-dialog-title>اطلاعات زیر را با دقت پر بفرمایید</h1>
    <div mat-dialog-content>
      <app-input-field
        [Group]="formGroup"
        [fieldLabel]="'نام'"
        [fieldName]="'firstName'"
        [dataType]="['varchar']"
      ></app-input-field>
      <app-input-field
        [Group]="formGroup"
        [fieldLabel]="'نام خانوادگی'"
        [fieldName]="'lastName'"
        [dataType]="['varchar']"
      ></app-input-field>
      <app-select-field
        [Group]="formGroup"
        [fieldName]="'relation'"
        [fieldLabel]="'رابطه'"
        [options]="relationList"
      ></app-select-field>
    </div>
    <div mat-dialog-actions>
      <button mat-button (click)="onNoClick()">بازگشن</button>
      <button mat-button [disabled]="!formGroup.valid" [mat-dialog-close]="getNewSubset()" cdkFocusInitial>تایید
      </button>
    </div>
  `,
})
export class NewSubSetDialogComponent {
  formGroup: FormGroup = this.fb.group({
    firstName: ['', Validators.required],
    lastName: ['', Validators.required],
    relation: ['', Validators.required],
  });
  relationList: Option[] = [];

  constructor(
    public dialogRef: MatDialogRef<NewSubSetDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData, private fb: FormBuilder) {
    this.relationList = data.relationList;
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  getNewSubset() {
    return new Subset(
        this.formGroup.controls.firstName.value,
      this.formGroup.controls.lastName.value,
      this.formGroup.controls.relation.value
    );
  }
}
